import { render, staticRenderFns } from "./lbInfo.vue?vue&type=template&id=ddfa3e36&scoped=true"
import script from "./lbInfo.vue?vue&type=script&lang=js"
export * from "./lbInfo.vue?vue&type=script&lang=js"
import style0 from "./lbInfo.vue?vue&type=style&index=0&id=ddfa3e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfa3e36",
  null
  
)

export default component.exports